import clsx from "clsx";
import s from "./style.module.scss";

interface StepperProps {
  step: number;
}
export const Stepper = ({ step }: StepperProps) => {
  return (
    <div className={s.stepper}>
      {[0, 1, 2].map((index) => (
        <div className={clsx(s.step, step >= index && s.active)}></div>
      ))}
    </div>
  );
};
